import { render, staticRenderFns } from "./AddLimitModal.vue?vue&type=template&id=23435ec8&scoped=true&"
import script from "./AddLimitModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddLimitModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AddLimitModal.vue?vue&type=style&index=0&id=23435ec8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23435ec8",
  null
  
)

export default component.exports